import React from 'react';
import {connect} from 'react-redux';
import includes from 'lodash/includes';
import compose from 'recompose/compose';
import {bindSelector} from 'utils/DBUtils';
import ConditionalRedirect from './ConditionalRedirect';
import {
    getUserGroupName,
    getUserResourceActions,
    getUserServiceActions
} from 'pages/Profile/selectors';

export const UserGroupFilter = (...authorizedGroups) => compose(
    connect(state => ({
        userGroup: getUserGroupName(state)
    })),
    ConditionalRedirect({
        redirectUrl: '/no-access',
        condition: props => includes(authorizedGroups, props.userGroup)
    })
);

// Resource API permission types are mostly CRUD; DOWNLOAD may get split into different
// Service API actions in the future.
const ResourcePermissionTypes = {
    CREATE: null,
    READ: null,
    EDIT: null,
    DELETE: null,
    DOWNLOAD: null
};

const GlobalResourceType = 'all';

// pass in a map of ResourceApi.Types to permissions and get back a HOC that wraps a route
// component that will redirect to the "no access" page if the user does not have the
// specified permissions.
//
// the resource permissions map will look something like this:
//   {
//     [ResourceApi.Types.Break]: ['READ'],
//     [ResourceApi.Types.User]: [
//       'AWARD_POINTS',
//       'REVOKE_POINTS',
//       'CANCEL_TRANSACTION'
//     ]
//   }
export const PermissionsFilter = permissionsMap => compose(
    connect(state => ({
        getResourceActions: bindSelector(getUserResourceActions, state),
        getServiceActions: bindSelector(getUserServiceActions, state)
    })),
    ConditionalRedirect({
        redirectUrl: '/no-access',
        condition: props => {
            // iterate over each Resource type in the permissions map.
            const hasAllExpectedPermissions = Object.keys(permissionsMap).every(key => {

                // API resource types are lower-case.
                const resourceType = key.toLowerCase();

                // the list of expected permissions for this Resource type.
                const expectedPermissions = permissionsMap[key];

                // iterate over each permission type in the list of permissions for this
                // Resource type.
                const hasExpectedPermissions = expectedPermissions.every(permission => {

                    // API permission types are upper-case.
                    const expectedPermission = permission.toUpperCase();

                    // choose selector based on whether it's a Resource API permission
                    // type or a Service API one.
                    const selector = expectedPermission in ResourcePermissionTypes
                        ? 'getResourceActions'
                        : 'getServiceActions';

                    // get the list of actual permissions for this Resource type from the
                    // user's profile.
                    const actualPermissions = props[selector](resourceType);

                    // this expected permission is either in that list or not.
                    const hasAllPermissionsForType = includes(actualPermissions, expectedPermission);
                    return hasAllPermissionsForType;
                });

                // true if user has all expected permissions for this Resource type
                return hasExpectedPermissions;
            });

            // true if user has all expected permissions for all Resource types specified
            // in the permissionsMap.
            return hasAllExpectedPermissions;
        }
    })
);



// WEBPACK FOOTER //
// ./public/hoc/authorization.js